import React, {useState} from "react";
import {IconButton, Tooltip} from "@mui/material";
import {IconLock, IconLockOpen} from "@tabler/icons-react";
import {useFlowProtection} from "../hooks/useFlowProtection";
import {FlowProtectionAuthModal} from "./modals/FlowProtectionAuthModal";

/**
 * Icon button that opens a modal to enter a flow's protection password.
 * Once unlocked, protected user messages for that flow are shown unmasked
 * for a limited time (see useFlowProtection). Drop this next to the debug
 * toggle in any conversation toolbar.
 */
export const FlowProtectionButton = ({flowUid, size = "small", iconSize = 22}) => {
  const [open, setOpen] = useState(false);
  const {isUnlocked, unlock} = useFlowProtection(flowUid);

  if (!flowUid) return null;

  return (
    <>
      <Tooltip title={isUnlocked ? "Protected messages unlocked" : "Unlock protected messages"}>
        <IconButton
          size={size}
          color={isUnlocked ? "success" : "default"}
          onClick={() => setOpen(true)}
        >
          {isUnlocked ? <IconLockOpen size={iconSize}/> : <IconLock size={iconSize}/>}
        </IconButton>
      </Tooltip>
      <FlowProtectionAuthModal
        open={open}
        flowUid={flowUid}
        onClose={() => setOpen(false)}
        onSuccess={(token, expiresInSeconds) => unlock(token, expiresInSeconds)}
      />
    </>
  );
};
